// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__4GlLC","menuWrap":"style_menuWrap__vWjeT","menuTitle":"style_menuTitle__bVMhw","menuGroup":"style_menuGroup__43OAY","menuItem":"style_menuItem__kyGGU"};